import type * as SentryTypes from '@sentry/types';

import { ReportException } from '../errors';
import { Logger } from '../logger';

const logger = Logger('exceptions');

/**
 * Enrich Sentry events with context attached to an error or ReportException wrapper.
 */
export function reportExceptionIntegration(): SentryTypes.Integration {
    return {
        name: 'ReportExceptionIntegration',
        setupOnce() {},
        processEvent(event: SentryTypes.Event, hint: SentryTypes.EventHint = {}) {
            if (!event.exception) {
                return event;
            }

            logger.info('reporting exception to Sentry with event ID', event.event_id);

            const options = ReportException.getOptions(hint.originalException);
            if (!options) {
                return event;
            }

            const { tags, extra, fingerprint, attachments } = options;

            if (attachments) {
                hint.attachments = attachments.map((attachment): SentryTypes.Attachment => ({
                    filename: attachment.name,
                    data: attachment.body,
                    contentType: attachment.type,
                }));
            }

            return {
                ...event,

                tags: {
                    ...(event.tags || {}),
                    ...(tags || {}),
                },
                extra: {
                    ...(event.extra || {}),
                    ...(extra || {}),
                },
                fingerprint: event.fingerprint?.length ? event.fingerprint : (fingerprint ?? []),
            };
        },
    };
}
